import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { StorageService } from '@insite-store360/services';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(
    private router: Router,
    private storageService: StorageService
  ) { }

  canActivate(
    _route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    const token = this.storageService.getToken();

    if (!token) {
      if (typeof localStorage !== 'undefined' && state.url && state.url !== '/') {
        localStorage.setItem('redirectUrl', state.url);
      }
      this.router.navigate(['/']);
      return false;
    }

    return true;
  }
}